module.exports = __webpack_public_path__ + "fonts/icomoon.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/icomoon/icomoon.ttf?1ki0q8
// module id = 398
// module chunks = 0